import { Role } from 'shared/data/walletsKyc/v1';
import { z } from 'zod';

import { schema } from '../../schema';
import { messages } from './PersonsTable.messages';

export const getFullName = ({ firstName, lastName }: z.infer<typeof schema>['people']['persons'][number]) => {
    return [firstName, lastName]
        .map((name) => name || '')
        .join(' ')
        .trim();
};

export const personRoleToMessage = {
    [Role.director]: messages.director,
    [Role.ultimate_business_owner]: messages.ultimateBusinessOwner,
};

export const getRoles = (roles: z.infer<typeof schema>['people']['persons'][number]['roles']) => {
    const mappedRoles = roles.filter((role) => role !== Role.user).map((role) => personRoleToMessage[role]);

    return mappedRoles.join(' / ');
};
